import { render, staticRenderFns } from "./TotalStock.vue?vue&type=template&id=ef3fbc5a&scoped=true"
import script from "./TotalStock.vue?vue&type=script&lang=js"
export * from "./TotalStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3fbc5a",
  null
  
)

export default component.exports